import { render, staticRenderFns } from "./GatGrid.vue?vue&type=template&id=0a063a58&scoped=true"
import script from "./GatGrid.vue?vue&type=script&lang=js"
export * from "./GatGrid.vue?vue&type=script&lang=js"
import style0 from "./GatGrid.vue?vue&type=style&index=0&id=0a063a58&prod&scoped=true&lang=css"
import style1 from "./GatGrid.vue?vue&type=style&index=1&id=0a063a58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a063a58",
  null
  
)

export default component.exports